import React from "react";
import { Button } from "reactstrap";

const CustomButton = ({ label, margin, width, color, style, ...rest }) => {
  return (
    <Button
      color={color || "primary"}
      style={{
        margin: margin || "30px 0px",
        color: "#000000",
        border: 0,
        width: width || "auto",
        ...style
      }}
      {...rest}>
      {label}
    </Button>
  );
};

export default CustomButton;
